// extracted by mini-css-extract-plugin
module.exports = {"menu":"ghEsP","item":"ysTVU"};